import { ApolloClient, ApolloLink, InMemoryCache, defaultDataIdFromObject, from } from '@apollo/client';
import cleanMutationLink from './getApolloCleanMutationLink';
import httpLink from './getApolloHttpLink';

const getApolloClient = async (tokenLink: ApolloLink) => {
  return new ApolloClient({
    link: from([cleanMutationLink, tokenLink, httpLink]),
    cache: new InMemoryCache({
      addTypename: true,
      typePolicies: {
        MasterDataCountryTranslation: { keyFields: ['code', 'name'] },
        MasterDataCitizenship: { keyFields: ['_id', 'name'] },
        MasterDataCitizenshipTranslation: { keyFields: ['code', 'name'] },
      },
      dataIdFromObject: (responseObject) => {
        return responseObject?._id && typeof responseObject._id === 'string'
          ? (responseObject._id as string)
          : defaultDataIdFromObject(responseObject);
      },
    }),
  });
};

export default getApolloClient;
